import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Link,
  Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  card: {
    height: 330,
    borderWidth: 0,
    borderRadius: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    transition: "all 0.5s ease",
    "&:hover": {
      // boxShadow: "0px 0px 20px rgba(0,0,0,0.4)",
      borderColor: theme.palette.primary.light,
    },
    [theme.breakpoints.down("md")]: {
      height: "auto",
      borderRadius: 10,
      boxShadow: "0px 0px 20px rgba(0,0,0,0.1)",
    },
  },
  root: {
    height: "inherit",
    // backgroundColor: "red",
  },
  CardHeader: {
    backgroundColor: theme.palette.secondary.main,

    // margin: 0,
    // paddingBottom: 10,
  },
  CardHeaderRoot: {
    backgroundColor: theme.palette.secondary.main,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    [theme.breakpoints.down("md")]: {
      height: "5vh",
      // boxShadow: "0px 0px 20px rgba(0,0,0,0.1)",

      // backgroundColor: "red",
    },
    // padding: 10,
  },
  CardHeaderTitle: {
    fontWeight: 600,
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
    },
    // color: theme.palette.primary.main,
  },
  link: {
    // marginTop: theme.spacing(1),
    // marginRight: theme.spacing(2),
  },
  CardContent: {
    height: "100%",
  },
  readmoreBtnContainer: {
    // backgroundColor: "red",

    display: "flex",
    justifyContent: "flex-end",
    padding: 15,
    [theme.breakpoints.down("md")]: {
      padding: 10,
      // boxShadow: "0px 0px 20px rgba(0,0,0,0.1)",

      // backgroundColor: "red",
    },
  },
  readmoreBtn: {
    borderRadius: 100,
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
    },
  },
}));

const ContainerCard = (props) => {
  const classes = useStyles();
  const history = useHistory();

  const handleNavigate = (link, extenral) => {
    if (extenral) {
      return window.open(link, "_blank");
    }
    history.push(link);
  };
  return (
    <div className={classes.root}>
      <Card className={classes.card} variant="outlined">
        <CardHeader
          classes={{
            root: classes.CardHeaderRoot,
          }}
          title={
            <div className={classes.CardHeader}>
              <Typography className={classes.CardHeaderTitle} variant="h5">
                {props.title || "title"}
              </Typography>
            </div>
          }
        />
        <CardContent className={classes.CardContent}>
          {props?.children}
        </CardContent>
        {props.link && (
          <div className={classes.readmoreBtnContainer}>
            <Button
              color="primary"
              variant="outlined"
              className={classes.readmoreBtn}
              onClick={() => handleNavigate(props.link)}
            >
              {props?.linkTitle}
            </Button>
          </div>
        )}
      </Card>
    </div>
  );
};
export default ContainerCard;
